import { render, staticRenderFns } from "./PaymentError.vue?vue&type=template&id=24644d98&scoped=true"
import script from "./PaymentError.vue?vue&type=script&lang=js"
export * from "./PaymentError.vue?vue&type=script&lang=js"
import style0 from "./PaymentError.vue?vue&type=style&index=0&id=24644d98&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24644d98",
  null
  
)

export default component.exports